import { ButtonViewModel } from '../../../model/home/button.view-model';
import { ContractInfos } from '../contract-infos';
import { Button } from './button';
import { ClientTypeEnum } from './clientType.enum';

export class Forbidden {
    public clientType: ClientTypeEnum;
    public cid: string;
    public title: string;
    public contractInfos?: ContractInfos;
    public subtitle?: string;
    public detail?: string;
    public text?: string[];
    public buttons?: Button[];
    public changeUniverse?: ButtonViewModel;
    public banner?: any;
    public isProtectedHouseV2?: boolean;
    public isInQuarantine?: boolean;
}
